import * as React from 'react';

import { Box, Text } from '@opendoor/bricks-next';

import FlowElement from 'src/components/fields/FlowElement';
import { EvaluatedFlowPage } from 'src/lib/flow/FlowPage';

interface FlowPageHeaderProps {
  title: string;
  subtitle?: string;
  subtitleElement?: EvaluatedFlowPage['subtitleElement'];
}

const FlowPageHeader = React.forwardRef<HTMLHeadingElement, FlowPageHeaderProps>(
  ({ title, subtitle, subtitleElement }, ref) => {
    return (
      <Box
        flexDirection="column"
        gap="$5x"
        $smallerThanMD={{ gap: '$8x' }}
        alignItems="flex-start"
        alignContent="flex-start"
      >
        {title && (
          <Box ref={ref}>
            <Text
              tag="h1"
              typography="$headerMedium"
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore - workaround for textWrap not being in the types
              style={{ textWrap: 'balance' }}
              lineHeight={55}
              $smallerThanMD={{ typography: '$subheaderMedium' }}
              id="question-title"
              // see if this is needed, original it was on all pages and then
              // A360 said to remove it, but we only removed it for the overview
              // page so either this is needed always and that was a
              // misunderstanding of how our app worked, or it's not needed for
              // any pages...
              aria-live="polite"
              my={0}
            >
              {title}
            </Text>
          </Box>
        )}
        {subtitle && (
          <Text tag="h2" typography="$bodyLarge" $smallerThanMD={{ typography: '$bodyMedium' }}>
            {subtitle}
          </Text>
        )}
        {subtitleElement && <FlowElement element={subtitleElement} />}
      </Box>
    );
  },
);

FlowPageHeader.displayName = 'FlowPageHeader';

export default FlowPageHeader;
